import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import {
  CompanyInactivePeriodDto,
  CompanyInactivePeriodMutationResultDto,
  CreateCompanyInactivePeriodRequest,
  UpdateCompanyInactivePeriodRequest
} from '../../models/api/companyInactivePeriodDto';

@Injectable({
  providedIn: 'root'
})
export class CompanyInactivePeriodService {
  private apiUrl = `${environment.apiUrl}/companies`;

  constructor(private http: HttpClient) {}

  getAll(companyId: string): Observable<CompanyInactivePeriodDto[]> {
    return this.http.get<CompanyInactivePeriodDto[]>(`${this.apiUrl}/${companyId}/inactive-periods`);
  }

  getById(companyId: string, id: string): Observable<CompanyInactivePeriodDto> {
    return this.http.get<CompanyInactivePeriodDto>(`${this.apiUrl}/${companyId}/inactive-periods/${id}`);
  }

  create(companyId: string, request: CreateCompanyInactivePeriodRequest): Observable<CompanyInactivePeriodMutationResultDto> {
    return this.http.post<CompanyInactivePeriodMutationResultDto>(`${this.apiUrl}/${companyId}/inactive-periods`, request);
  }

  update(companyId: string, id: string, request: UpdateCompanyInactivePeriodRequest): Observable<CompanyInactivePeriodMutationResultDto> {
    return this.http.put<CompanyInactivePeriodMutationResultDto>(`${this.apiUrl}/${companyId}/inactive-periods/${id}`, request);
  }

  delete(companyId: string, id: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${companyId}/inactive-periods/${id}`);
  }
}
